export enum intlPhoneCodes {
  norway = "+47",
}
